<template>
  <!-- <div class="box">
      <div class="box-modular">
        <img src="../img/directorylibrary.png" alt="" />
        <p class="box-num">{{ EnterpriseCount.normalCount }}</p>
        <p class="box-text">名录库主体</p>
      </div>
      <div class="box-modular">
        <img src="../img/abnormal.png" alt="" />
        <p class="box-num">{{ EnterpriseCount.abnormalCount }}</p>
        <p class="box-text">异常主体</p>
      </div>
      <div class="box-modular">
        <img src="../img/cancellation.png" alt="" />
        <p class="box-num">{{EnterpriseCount.cancelCount }}</p>
        <p class="box-text">注销主体</p>
      </div>
  </div> -->
  <div class="leader_cockpit_fzxz">
    <div class="leader_cockpit_fzxz_info">
      <div class="leader_cockpit_fzxz_info_center">
        <NumberDigitalFlop :num="EnterpriseCount.normalCount"></NumberDigitalFlop>
      </div>
      <div class="leader_cockpit_fzxz_info_center">
        名录库主体(个)
      </div>
    </div>
    <div class="leader_cockpit_fzxz_fgx"></div>
    <div class="leader_cockpit_fzxz_info">
      <div class="leader_cockpit_fzxz_info_center">
        <NumberDigitalFlop :num="EnterpriseCount.abnormalCount"></NumberDigitalFlop>
      </div>
      <div class="leader_cockpit_fzxz_info_center">
        异常主体(个)
      </div>
    </div>
    <div class="leader_cockpit_fzxz_fgx"></div>
    <div class="leader_cockpit_fzxz_info">
      <div class="leader_cockpit_fzxz_info_center">
        <NumberDigitalFlop :num="EnterpriseCount.cancelCount"></NumberDigitalFlop>
      </div>
      <div class="leader_cockpit_fzxz_info_center">
        注销主体(个)
      </div>
    </div>
    <div class="leader_cockpit_fzxz_fgx"></div>
    <div class="leader_cockpit_fzxz_info">
      <div class="leader_cockpit_fzxz_info_center">
        <NumberDigitalFlop :num="totals"></NumberDigitalFlop>
      </div>
      <div class="leader_cockpit_fzxz_info_center">
        示范社(个)
      </div>
    </div>
  </div>
</template>

<script>
import NumberDigitalFlop from './NumberFlop'
import Cookies from "js-cookie"
import API from "@/api/serviceOrgManagement/api_userManagement";
import API_SCREEN from "@/api/bigScreen/api_big_screen";
export default {
  components: {
    NumberDigitalFlop
  },
  data() {
    return {
      list: [
        // {
        //   img: "@/static/img/directorylibrary.png",
        //   num: "3000",
        //   text: "名录库主体",
        // },
        // {
        //   img: "../../../static/img/abnormal.png",
        //   num: "102",
        //   text: "异常主体",
        // },
        // {
        //   img: "../../../static/img/cancellation.png",
        //   num: "97",
        //   text: "注销主体",
        // },
      ],
      EnterpriseCount:[],
      qhdm: Cookies.get('areacode'),
      totals: 0
    };
  },
   created() {
     this.enterpriseStatEnterpriseCount()
     this.enterpriseStatGrade()
     this.GLOBAL.eventBus.$on("refresh_big_screen_info",this.queryData);
   },
   beforeDestroy(){
    this.GLOBAL.eventBus.$off("refresh_big_screen_info",this.queryData);
   },
    methods: {
      queryData(qhdm){
        this.qhdm = qhdm;
        this.enterpriseStatEnterpriseCount();
        this.enterpriseStatGrade()
      },
      async enterpriseStatEnterpriseCount() {
        const { code, data } = await API.enterpriseStatEnterpriseCount({qhdm: this.qhdm});
        if (code === 0) {
          this.EnterpriseCount = data;
        }
      },
      async enterpriseStatGrade() {
        const res = await API_SCREEN.getGradeList({qhdm:this.qhdm});
        if (res.code === 0) {
          res.data.list.some((item, i) => {
              if (item.gradeCode == '1905') {
                 data.list.splice(i, 1)
              }
            })

           this.totals= res.data.list.reduce((total, item) => {
            return total + item.gradeData.cityNum + item.gradeData.countryNum + item.gradeData.countyNum + item.gradeData.provincialNum
          }, 0)

          console.log('totals', this.totals, res.data.list)
      }
    },
    },

};
</script>

<!-- <style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.box {
// width: 100%;
  display: flex;
  justify-content: space-between;

}
.box-father{
    width: 100%;

}
.box-modular {
  display: flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
    // flex: 1;
  width:32%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 18px 0px rgba(18, 29, 54, 0.07);
  border-radius: 8px;
  // text-align: center;
  // padding: 20px 0;
  // margin-right: 20px;
  img {
    width: 50px;
    height: 50px;
    // margin-top: 20px;
  }
  .box-num {
    height: 20px;
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin: 5px 0 20px 0;
    // line-height: 34px;
  }

  .box-text {
    // width: 56px;
    height: 20px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    // line-height: 40px;
  }
}
</style> -->

<style lang="less" scoped>
  .leader_cockpit_fzxz {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #EEF0F3;

    .leader_cockpit_fzxz_fgx {
      width: 2px;
      height: 80px;
      background: linear-gradient(0deg, #02121A 0%, #21F3FF 50% , #02121A 100%);
    }

    .leader_cockpit_fzxz_info {
      &:not(:first-child), &:not(:last-child) {
        margin: 0 15px;
      }

      .leader_cockpit_fzxz_info_center{
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        margin-top: 8px;
        white-space: nowrap;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/homecentretop.vue